/**
 * svg 图标注册入口
 * 功能：注册 svg-icon 全局组件，并通过 require.context 批量加载 ./svg 目录下所有 .svg 文件
 */
import Vue from 'vue'
import SvgIcon from '@/components/SvgIcon'// svg component

// register globally
Vue.component('svg-icon', SvgIcon)

const req = require.context('./svg', false, /\.svg$/)
const requireAll = requireContext => requireContext.keys().map(requireContext)
requireAll(req)


